import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import DocumentList from './components/DocumentList';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route 
          path="/documents" 
          element={
            <ProtectedRoute>
              <DocumentList />
            </ProtectedRoute>
          } 
        />
        <Route path="/" element={<Navigate to="/documents" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
